export default __webpack_public_path__ + "static/media/sn25.cec690aa.jpg";